import React, { Component } from 'react'
import { AutoComplete, Button, Checkbox, Col, Icon, Input, Row, Select } from 'antd'
import InputNumber from 'rc-input-number'
import numeral from 'numeral'
import _ from 'lodash'

import * as totalCalculator from '../../utils/totalCalculator'
import SmartInputNumber from '../SmartInputNumber/SmartInputNumber'
import UploadWithPopupPreview from '../UploadWithPopupPreview/UploadWithPopupPreview'
import 'antd/lib/input-number/style/css';
import './TemplateContentForm.scss'

const { Option } = Select
const { getItemTotal, getSectionTotal } = totalCalculator

export default class TemplateContentForm extends Component {
    handleItemNameRemove(e, itemName) {
        const { token, removeItemName } = this.props
        e.stopPropagation()
        removeItemName(token, itemName)
    }
    
    renderSmartSearchFilter() {
        const { smartSaerchFilter, onSmartSearchFilterChange, locationList, estateList } = this.props
        const { category, type, size, siteLocation, estateName } = smartSaerchFilter

        return (
            <div className="smart-search-filter">
                <h3>Please select filter to limit the smart suggestion result.</h3>
                <div className="filter-gp">
                    <Select 
                        placeholder="Category" 
                        dropdownMatchSelectWidth={false} 
                        value={category}
                        onChange={onSmartSearchFilterChange.bind(this, 'category')}
                        allowClear
                    >
                        <Option value="RE">RE</Option>
                        <Option value="OF">OF</Option>
                        <Option value="MI">MI</Option>
                    </Select>
                    <Select 
                        placeholder="Type" 
                        dropdownMatchSelectWidth={false} 
                        value={type}
                        onChange={onSmartSearchFilterChange.bind(this, 'type')}
                        allowClear
                    >
                        <Option value="Apartment">Apartment</Option>
                        <Option value="House">House</Option>
                        <Option value="Subdivided Flat">Subdivided Flat</Option>
                        <Option value="Shop">Shop</Option>
                        <Option value="NGO">NGO</Option>
                        <Option value="Restaurant">Restaurant</Option>
                        <Option value="Elderly House">Elderly House</Option>
                        <Option value="School">School</Option>
                        <Option value="Office">Office</Option>
                    </Select>
                    <Select 
                        placeholder="Size" 
                        dropdownMatchSelectWidth={false} 
                        value={size}
                        onChange={onSmartSearchFilterChange.bind(this, 'size')}
                        allowClear
                    >
                        <Option value="<= 300">&lt;= 300</Option>
                        <Option value="301 - 500">301 - 500</Option>
                        <Option value="501 - 800">501 - 800</Option>
                        <Option value="> 800">&gt; 800</Option>
                    </Select>
                    <Select 
                        placeholder="Location" 
                        dropdownMatchSelectWidth={false} 
                        value={siteLocation}
                        onChange={onSmartSearchFilterChange.bind(this, 'siteLocation')}
                        allowClear
                    >
                        {
                            _.map(locationList, (location, i) => (
                                <Option key={location} value={location}>{location}</Option>
                            ))
                        }
                    </Select>
                    <Select 
                        placeholder="Estate" 
                        dropdownMatchSelectWidth={false} 
                        value={estateName}
                        onChange={onSmartSearchFilterChange.bind(this, 'estateName')}
                        allowClear
                    >
                        {
                            _.map(estateList, (estate, i) => (
                                <Option key={estate} value={estate}>{estate}</Option>
                            ))
                        }
                    </Select>
                </div>
            </div>
        )
    }

    renderItemRow(sectionIdx, itemList) {
        const {
            itemNameSuggestionList,
            unitSuggestionList,
            itemSmartSuggestionList,
            onSuggestionItemClick,
            onItemInsert,
            onItemFocus,
            onItemRemove,
            onItemChange
        } = this.props
        const itemNameOptions = _.map(itemNameSuggestionList, (itemName, idx) => (
            <Option key={itemName}>
                {itemName}
                <div className="item-name-delete-btn" onClick={(e) => this.handleItemNameRemove(e, itemName)}>
                    <Icon type="close" />
                </div>
            </Option>
        ))

        return _.map(itemList, (item, itemIdx) => {
            const { name, quantity, basic_charge_quantity, basic_charge, unit_rate, unit, imageUrl, optional } = item

            return (
                <tr key={`${sectionIdx}-${itemIdx}`}>
                    <td className="insert-item-field">
                        <div className="insert-item-btn" onClick={onItemInsert.bind(this, sectionIdx, itemIdx)}>
                            <Icon type="rollback" />
                        </div>
                    </td>
                    <td className="item-idx-field">{sectionIdx + 1}.{itemIdx + 1}</td>
                    <td className="item-name-field">
                        <AutoComplete
                            value={name}
                            onChange={onItemChange.bind(this, sectionIdx, itemIdx, 'name')}
                            dataSource={itemNameOptions}
                            optionLabelProp='value'
                            style={{width: '100%'}}
                            filterOption={(inputValue, option) => option.props.children[0].toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
                            dropdownMatchSelectWidth={false}
                        />
                    </td>
                    <td width={60}>
                        <InputNumber
                            prefixCls="ant-input-number" 
                            value={quantity}
                            onChange={onItemChange.bind(this, sectionIdx, itemIdx, 'quantity')}
                        />
                    </td> 
                    <td width={80}>
                        <SmartInputNumber 
                            prefixCls="ant-input-number"
                            min={1} 
                            formatter={value => value ? `First ${value}` : ''}
                            parser={value => value.replace(/[^0-9.]/g, '')}
                            value={basic_charge_quantity}
                            onChange={onItemChange.bind(this, sectionIdx, itemIdx, 'basic_charge_quantity')}
                            onFocusFetcher={onItemFocus.bind(this, sectionIdx, itemIdx)}
                            onRowClick={(selectedItem) => onSuggestionItemClick(sectionIdx, itemIdx, selectedItem)}
                            itemName={name}
                            itemSmartSuggestionList={itemSmartSuggestionList}
                        />
                    </td>
                    <td width={80}>
                        <SmartInputNumber 
                            prefixCls="ant-input-number" 
                            formatter={value => value ? `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}
                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                            value={basic_charge}
                            min={0}
                            onChange={onItemChange.bind(this, sectionIdx, itemIdx, 'basic_charge')}
                            onFocusFetcher={onItemFocus.bind(this, sectionIdx, itemIdx)}
                            onRowClick={(selectedItem) => onSuggestionItemClick(sectionIdx, itemIdx, selectedItem)}
                            itemName={name}
                            itemSmartSuggestionList={itemSmartSuggestionList}
                        />
                    </td>
                    <td width={70}>
                        <SmartInputNumber 
                            prefixCls="ant-input-number" 
                            formatter={value => value ? `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}
                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                            value={unit_rate}
                            min={0}
                            onChange={onItemChange.bind(this, sectionIdx, itemIdx, 'unit_rate')}
                            onFocusFetcher={onItemFocus.bind(this, sectionIdx, itemIdx)}
                            onRowClick={(selectedItem) => onSuggestionItemClick(sectionIdx, itemIdx, selectedItem)}
                            itemName={name}
                            itemSmartSuggestionList={itemSmartSuggestionList}
                        />
                    </td>
                    <td width={50}>
                        <AutoComplete
                            value={unit}
                            onChange={onItemChange.bind(this, sectionIdx, itemIdx, 'unit')}
                            dataSource={unitSuggestionList}
                            style={{width: '100%'}}
                            filterOption={(inputValue, option) => option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
                            dropdownMatchSelectWidth={false}
                        />
                    </td>
                    <td><div className="table-item">{numeral(getItemTotal(item)).format('$ 0,0.[0]')}</div></td>
                    <td>
                        <UploadWithPopupPreview
                            itemImageUrl={imageUrl}
                            itemImageChange={(url) => onItemChange(sectionIdx, itemIdx, 'imageUrl', url)}
                        />
                    </td>
                    <td>
                        <Checkbox 
                            checked={optional} 
                            onChange={onItemChange.bind(this, sectionIdx, itemIdx, 'optional')}
                        />
                    </td>
                    <td>
                        <div className="rm-item-btn" onClick={onItemRemove.bind(this, sectionIdx, itemIdx)}>
                            <Icon type="close" />
                        </div>
                    </td>
                </tr>
            )
        })
    }

    renderRemarkRow(sectionIdx, remarkList) {
        const {
            onSectionRemarkInsert,
            onSectionRemarkRemove,
            onSectionRemarkChange
        } = this.props

        return _.map(remarkList, (remark, remarkIdx) => {
            return (
                <tr key={`${sectionIdx}-${remarkIdx}`} className="remark-row">
                    <td className="remark-insert-field">
                        <div className="insert-item-btn" onClick={onSectionRemarkInsert.bind(this, sectionIdx, remarkIdx)}>
                            <Icon type="rollback" />
                        </div>
                    </td>
                    <td colSpan={10} className="remark-field">
                        <Input 
                            placeholder={'Input remark content'}
                            value={remark} 
                            onChange={onSectionRemarkChange.bind(this, sectionIdx, remarkIdx)}
                        />
                    </td>
                    <td className="remark-rm-field">
                        <div className="rm-item-btn" onClick={onSectionRemarkRemove.bind(this, sectionIdx, remarkIdx)}>
                            <Icon type="close" />
                        </div>
                    </td>
                </tr>
            )
        })
    }

    renderSectionRow() {
        const {
            sections,
            onItemAdd,
            onSectionChange,
            onSectionRemove,
            onSectionToggle,
            onSectionRemarkAdd
        } = this.props

        return _.map(sections, (section, sectionIdx) => (
            <div className="section" key={sectionIdx}>
                <div className="section-header">
                    <div className="section-idx">{sectionIdx + 1}.0</div>
                    <div className="section-name">
                        <Input 
                            placeholder={'Input section name'}
                            value={section.name} 
                            onChange={onSectionChange.bind(this, sectionIdx, 'name')}
                        />
                    </div>
                    <div className="right-control">
                        <div className={`toggle-btn${section.toggled ? ' toggled' : ''}`} onClick={onSectionToggle.bind(this, sectionIdx)}>
                            <Icon type="up" />
                        </div>
                        <div className="rm-section-btn" onClick={onSectionRemove.bind(this, sectionIdx)}>
                            <Icon type="close" />
                        </div>
                    </div>
                </div>
                <table className={`item-table${section.toggled ? ' toggled' : ''}`}>
                    <thead>
                        <tr>
                            <th width={40}></th>
                            <th width={40}></th>
                            <th>Item</th>
                            <th width={60}>Qty</th>
                            <th width={60} colSpan={2}>Basic Charge</th>
                            <th width={60} colSpan={2}>Unit Rate</th>
                            <th width={100}>Total</th>
                            <th width={40}>Image</th>
                            <th width={40}>Optional</th>
                            <th width={40}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderItemRow(sectionIdx, section.items)}
                        <tr className="add-item">
                            <td colSpan={12}>
                                <Button onClick={onItemAdd.bind(this, sectionIdx)}>
                                    Add Item
                                </Button>
                            </td>
                        </tr>
                        {this.renderRemarkRow(sectionIdx, section.remarks)}
                        <tr className="add-remark">
                            <td colSpan={12}>
                                <Button onClick={onSectionRemarkAdd.bind(this, sectionIdx)}>
                                    Add Remark
                                </Button>
                            </td>
                        </tr>
                        <tr className="sub-total">
                            <td colSpan={10}>
                                Sub-total
                            </td>
                            <td colSpan={2}>
                                {numeral(getSectionTotal(section.items)).format('$ 0,0.[0]')}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        ))
    }

    renderDiscountSection() {
        const { onDiscountAdd, onDiscountRemove, onDiscountChange, discounts } = this.props

        return (
            <div className="discount-gp">
                { 
                    _.map(discounts, (discount, discountIdx) => (
                        <Row gutter={8} className="discount-row" key={`discount-${discountIdx}`}>
                            <Col span={20}>
                                <Input 
                                    placeholder="Input discount name"
                                    value={discount.name} 
                                    onChange={onDiscountChange.bind(this, discountIdx, 'name')}
                                />
                            </Col>
                            <Col span={3}>
                                <InputNumber 
                                    className="discount-amount"
                                    prefixCls="ant-input-number" 
                                    formatter={value => value ? `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}
                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                    value={discount.amount} 
                                    onChange={onDiscountChange.bind(this, discountIdx, 'amount')}
                                />
                            </Col>
                            <Col span={1}>
                                <div className="rm-discount-btn" onClick={onDiscountRemove.bind(this, discountIdx)}>
                                    <Icon type="close" />
                                </div>
                            </Col>
                        </Row>
                    ))
                }
                <Button key="add-discount-btn" className="add-discount-btn" onClick={onDiscountAdd.bind(this)}>Add Discount</Button>
            </div>
        )
    }

    render() {
        const { onSectionAdd, grandTotal } = this.props

        return (
            <div className="TemplateContentForm">
                {this.renderSmartSearchFilter()}
                <div className="content-table">
                    {this.renderSectionRow()}
                    <Button type="primary" size="large" onClick={onSectionAdd.bind(this)}>Add Section</Button>
                    {this.renderDiscountSection()}
                    <div className="grand-total">Grand Total: {numeral(grandTotal).format('$ 0,0.[0]')}</div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Commons/TemplateContentForm/TemplateContentForm.js